/**
 * Keeps the mobile-menu cart link (#cart-icon-bubble-mobile) in sync with the cart.
 * The main header icon (#cart-icon-bubble) is refreshed by Dawn's section rendering
 * in cart.js / cart-drawer.js / cart-notification.js.
 */
(function () {
  function updateMobileCartCount(count) {
    var link = document.getElementById('cart-icon-bubble-mobile');
    if (!link) return;

    var bubble = link.querySelector('.cart-count-bubble');
    if (count > 0) {
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        link.appendChild(bubble);
      }
      bubble.innerHTML =
        (count < 100 ? '<span aria-hidden="true">' + count + '</span>' : '') +
        '<span class="visually-hidden">' + count + '</span>';
    } else if (bubble) {
      bubble.remove();
    }
  }

  function refreshFromCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateMobileCartCount(cart.item_count); })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.cartData && typeof event.cartData.item_count === 'number') {
          updateMobileCartCount(event.cartData.item_count);
        } else {
          return refreshFromCart();
        }
      });
    }
  });


  /**
   * Back/forward cache fix: when the browser restores a page from bfcache
   * (e.g. Back button after changing the cart on /cart), the old DOM is shown
   * as-is: stale header count and the "Item added" popup/drawer still open.
   * On restore we close those and re-render the header icon from the live cart.
   */
  function closeCartPopups() {
    var notification = document.getElementById('cart-notification');
    if (notification) notification.classList.remove('active');

    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      drawer.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    }
  }

  function refreshHeaderIcon() {
    var root = (window.routes && window.routes.root_url) || '/';
    if (root.slice(-1) !== '/') root += '/';

    return fetch(root + '?sections=cart-icon-bubble&t=' + Date.now(), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-icon-bubble'];
        var target = document.getElementById('cart-icon-bubble');
        if (!html || !target) return;
        var section = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (section) target.innerHTML = section.innerHTML;
      })
      .then(refreshFromCart)
      .catch(function () {});
  }

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    closeCartPopups();
    refreshHeaderIcon();
  });

  // Custom jQuery/ringbuilder add-to-cart code can call this after /cart/add.js
  window.tpsRefreshCartIcon = refreshFromCart;
})();